// extracted by mini-css-extract-plugin
export default {"content":"style_content__sF9d-","itemName":"style_itemName__QsoqI"};